var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stage-info-wrapper"},[_c('h2',{staticClass:"stage-info-title"},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"stage-info-content"},[_vm._v(_vm._s(_vm.info))])])}
var staticRenderFns = []

export { render, staticRenderFns }